import { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormGroup,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { useParams } from "react-router-dom";
import Button from "components/Inputs/TButton";
import Alert from "components/Alert";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Client from "services/WebAPI";
import { alertActions } from "redux/_actions";

const PartnerForm = (props) => {
  const d = new Date();

  const [formState, setFormState] = useState({
    invoiceDate: moment(d).format("YYYY-MM-DD"),
    dueDate: moment(new Date(d.setDate(d.getDate() + 15))).format("YYYY-MM-DD"),
    productId: 0,
    quantity: 0,
    amount: 0,
  });
  const [tier, setTier] = useState([]);
  const [units, setUnit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [generateLoading, setGLoading] = useState(false);
  const { id, type } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchTier();
    fetchEndpoints();
  }, [props.partner]);

  useEffect(() => {
    formState.quantity = units || 0;
    setFormState(formState);
  }, [units]);

  useEffect(() => {
    formState.amount =
      tier.filter((i) => i.ProductID === formState.productId)[0]?.Price || 0;
    setFormState({ ...formState });
  }, [formState.productId]);

  const [invalidFormState, setInvalidFormState] = useState({
    invoiceDate: false,
    dueDate: false,
    productId: false,
    quantity: false,
    amount: false,
  });

  const fetchEndpoints = async () => {
    try {
      setLoading(true);
      const resp = await Client.get(`/Endpoints/${type==="partner" ? "ListFromPartner" : "ListFromCustomer"}/` + id);
      if (resp.data.status) {
        setUnit(
          resp.data.data.filter((i) => i.ActivationStatus === "Activated")
            ?.length
        );
      }
    } catch (err) {
      console.log("err", err);
    }
    setLoading(false);
  };

  const fetchTier = async () => {
    try {
      const resp = await Client.get("/Billing/BillingTiers");
      if (resp.data.status && resp.data.result) setTier(resp.data.result);
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleSave = async (e) => {
    try {
      e.preventDefault();
      setGLoading(true);
      const { dueDate, productId, quantity, amount } = formState;
      const req = {
        Price: parseFloat(amount),
        ProductId: productId,
        Quantity: parseInt(quantity),
        DueDate: dueDate,
      };
      if(type==="partner") req.PartnerId=parseInt(id)
      if(type==="customer") req.CustomerId=parseInt(id)
      const resp = await Client.post("/Billing/ExecuteManualBilling", req);
      if (resp.data.status) {
        dispatch(alertActions.success("Invoice generated!"));
        setFormState({
          invoiceDate: moment(d).format("YYYY-MM-DD"),
          dueDate: moment(new Date(d.setDate(d.getDate() + 15))).format(
            "YYYY-MM-DD"
          ),
          productId: 0,
          quantity: 0,
          amount: 0,
        });
      } else dispatch(alertActions.error("Failed to Generate"));
    } catch (err) {
      console.log("err", err);
      dispatch(alertActions.error("Something went wrong"));
    }
    setGLoading(false);
    setTimeout(() => {
      dispatch(alertActions.clear());
    }, [2500]);
  };

  const handleFormValueChange = ({ target: { id, value } }) => {
    invalidFormState[id] = false;
    formState[id] = value;
    setFormState({ ...formState });
    setInvalidFormState({ ...invalidFormState });
  };

  return loading ? (
    <Spinner
      size="sm"
      style={{
        position: "absolute",
        left: "50%",
        transform: "transform: translate(-50%, -50%)",
      }}
    />
  ) : (
    <Form role="form" style={{ maxWidth: "100%" }} onSubmit={handleSave}>
      <FormGroup>
        <Alert />
      </FormGroup>
      <FormGroup>
        <Label for="invoiceDate">Invoice Date</Label>
        <Input
          id="invoiceDate"
          value={formState.invoiceDate}
          invalid={invalidFormState.invoiceDate}
          onChange={handleFormValueChange}
          type="date"
          disabled
        />
        <FormFeedback>Please enter a invoice date</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="dueDate">Due Date</Label>
        <Input
          id="dueDate"
          value={formState.dueDate}
          invalid={invalidFormState.dueDate}
          onChange={handleFormValueChange}
          type="date"
        />
        <FormFeedback>Please enter a due date</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="productId">Product</Label>
        <Input
          id="productId"
          value={formState.productId}
          invalid={invalidFormState.productId}
          onChange={handleFormValueChange}
          type="select"
        >
          <option disabled value={0}>
            Select
          </option>
          {tier.map((i) => (
            <option key={parseInt(i.Id)} value={i.ProductID}>
              {i.Tier}-{i.ProductID}
            </option>
          ))}
        </Input>
        <FormFeedback>Please select a product id</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="quantity">Quantity</Label>
        <Input
          type="number"
          id="quantity"
          value={formState.quantity}
          invalid={invalidFormState.quantity}
          onChange={handleFormValueChange}
        />
        <FormFeedback>Please enter Quantity</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="amount">Unit Price</Label>
        <Input
          type="number"
          id="amount"
          value={formState.amount}
          invalid={invalidFormState.amount}
          onChange={handleFormValueChange}
        />
        <FormFeedback>Please enter unit price</FormFeedback>
      </FormGroup>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            marginTop: 30,
            display: "flex",
            float: "right",
          }}
        >
          <div>
            <i>Net amount excluding taxes</i>
            <div style={{ justifyContent: "end" }}>
              <strong>
                ${parseInt(formState.quantity) * parseFloat(formState.amount)}
              </strong>
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 30,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button className="common-btn" type="submit">
            {generateLoading && (
              <Spinner size="sm" style={{ marginRight: "5px" }} />
            )}
            Generate
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default PartnerForm;
